<template>
  <el-table :data="data" style="width: 100%" :empty-text="$t('common.no_values')" @select-all="handleSelectAll" @select="handleSelectRow">
    <user-info-table-column width="400" :label="$t('branch.list_branch.name_column')" sortable prop="name" :is-show-email="false" screen="branch" />
    <el-table-column
        sortable
        :label="$t('branch.list_branch.manager_column')"
        prop="admin"
        align="left"
        :formatter="(row, colunm, cellValue) => formatAdmin(row.admin)"
        >
    </el-table-column>
    <el-table-column dataType="date" :sort-method="sortCreationDate" sortable :label="$t('branch.list_branch.creation_column')">
        <template slot-scope="scope">
            <span>{{ formatDate(scope.row.created_at) }}</span>
        </template>
    </el-table-column>
    <el-table-column :label="$t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'teachers_page.table.number_of_classes'))" sortable prop="classes" align="center" />

    <el-table-column :label="$t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'teachers_page.table.number_of_students'))" sortable prop="learners" align="center" />

    <!-- <el-table-column>
      <template slot-scope="scope">
        <div class="flex">
          <span class="edit-teacher" @click="edit(scope.row)" :title="$t($i18nLabelsHelper(currentOrganizationType, 'update_teacher_from_organization'))">
            <i class="elsa-icon-edit" />
          </span>
          <span class="remove-learner" @click="remove(scope.row.id)" :title="$t($i18nLabelsHelper(currentOrganizationType, 'remove_teacher_from_organization'))">
            <i class="elsa-icon-grey-delete" />
          </span>
        </div>
      </template>
    </el-table-column> -->
  </el-table>
</template>

<script>
import UserInfoTableColumn from '@/components/classes/UserInfoTableColumn'
import { mapGetters } from 'vuex'
import { always, identity, propOr } from 'ramda'
import { format } from 'date-fns'

export default {
  props: {
    data: {
      type: Array,
      default: always([])
    },
    handleSelectAll: {
      type: Function,
      default: identity
    },
    handleSelectRow: {
      type: Function,
      default: identity
    },
    handleRemove: {
      type: Function,
      default: identity
    },
    handleUpdate: {
      type: Function,
      default: identity
    },
    dateFormat: {
      type: String,
      default: 'dd/MM/yyyy'
    }
  },
  components: {
    UserInfoTableColumn,
  },
  computed: {
    getOrganizationGroups: propOr([], 'getClassList'),
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType'
    })
  },
  methods: {
    remove(id) {
      this.handleRemove(id)
    },
    edit(teacher) {
      this.handleUpdate(teacher)
    },
    formatAdmin(admin) {
        if (admin.first_name || admin.last_name) {
            return `${admin.first_name} ${admin.last_name}`
        } else {
            return admin.email;
        }
    },
    formatDate(date) {
      return date ? format(new Date(date), this.dateFormat) : '--'
    },
    sortCreationDate(obA, obB) {
      if (obA.created_at && obB.created_at) {
        return obA.created_at.localeCompare(obB.created_at)
      } else if (obA.created_at) {
        return 1
      } else if (obB.created_at) {
        return -1
      } else {
        return 0
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
